import { useState } from "react";
import { X } from "lucide-react";

const PromoBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="relative bg-gradient-to-r from-primary/90 via-primary to-primary/90 py-2 px-4 text-center">
      <p className="text-sm font-semibold text-primary-foreground">
        <span className="hidden sm:inline">Code promo : </span>
        <span className="font-bold tracking-wider text-white">PROMO20</span>
        <span className="mx-1 text-primary-foreground/80">—</span>
        <span>-20% sur toutes les offres !</span>
      </p>
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-primary-foreground/60 hover:text-primary-foreground transition-colors"
        aria-label="Fermer le bandeau promo"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default PromoBanner;
